import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeliverableService } from '../../services/deliverable.service';
import { Deliverable } from '../../models/deliverable';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-deliverable',
  imports: [CommonModule],
  templateUrl: './deliverable.component.html',
  styleUrl: './deliverable.component.css'
})
export class DeliverableComponent implements OnInit {

  @Input() deliverable!: Deliverable;

  constructor(private route: ActivatedRoute, private deliverableService: DeliverableService ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id')!;
    this.deliverableService.getDeliverable(id).subscribe({
      next: (result) => {
        this.deliverable = result;
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

}
